import React from "react";
import { Link } from "react-router-dom";

import CTA from "../../components/CTA";
import ContactTwo from "../../components/Contact/ContactTwo";
import Breadcrumb from "../../components/Breadcrumb";

import aboutImg from "../../assets/img/about/about-1.jpg";
import aboutImg2 from "../../assets/img/about/about-2.jpg";

const HomeMain = () => {
  return (
    <main>
      <Breadcrumb pageTitle="About Me" />

      <div className="about-5__area about-5__plr">
        <div className="container-fluid">
          <div className="about-5__border">
            <div className="row align-items-center">
              <div
                className="col-xl-5 col-lg-5 wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
              >
                <div className="about-5__main-img text-center text-lg-start">
                  <img src={aboutImg} alt="Ayush Mishra - App Developer" />
                </div>
              </div>
              <div className="col-xl-7 col-lg-7">
                <div className="about-5__content-box">
                  <h4
                    className="about-5__content-title wow tpfadeUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".5s"
                  >
                    About Me:
                  </h4>
                  <div className="about-5__content">
                    <div
                      className="about-5__text wow tpfadeUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".6s"
                    >
                      <p>
                        I'm Ayush Mishra, a full-stack developer based in Delhi,
                        India who builds web apps, mobile apps, and desktop
                        applications that solve real business problems. Using
                        React and React Native, I create custom software
                        solutions that streamline operations, automate
                        workflows, and boost efficiency for businesses of all
                        sizes.
                      </p>
                    </div>
                    <div
                      className="about-5__content-list wow tpfadeUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".7s"
                    >
                      <ul>
                        <li>
                          <i className="fal fa-check-circle"></i>
                          <span>Name: Ayush Mishra</span>
                        </li>
                        <li>
                          <i className="fal fa-check-circle"></i>
                          <span>Location: Delhi, India</span>
                        </li>
                        <li>
                          <i className="fal fa-check-circle"></i>
                          <span>Platforms: Web | Mobile | Desktop Apps</span>
                        </li>
                        <li>
                          <i className="fal fa-check-circle"></i>
                          <span>Technologies: React & React Native</span>
                        </li>
                        <li>
                          <i className="fal fa-check-circle"></i>
                          <span>Availability: Open for New Projects</span>
                        </li>
                        <li>
                          <i className="fal fa-check-circle"></i>
                          <span>Email: ayushmishra7352@gmail.com</span>
                        </li>
                      </ul>
                    </div>
                    <div
                      className="about-5__button wow tpfadeUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".9s"
                    >
                      <Link
                        className="main-btn tp-btn-hover alt-color"
                        to="/projects"
                      >
                        <span>View My Projects</span>
                        <b></b>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="about-details__area about-details__plr">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div
              className="col-xl-6 col-lg-6 wow tpfadeLeft"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div className="about-details__main-img">
                <img src={aboutImg2} alt="Ayush Mishra Development Workspace" />
              </div>
            </div>
            <div
              className="col-xl-6 col-lg-6 wow tpfadeRight"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <div className="about-details__content">
                <h4 className="about-details__title">
                  What I Build & How I Help:
                </h4>
                <div className="about-details__text">
                  <p>
                    I specialize in creating applications that transform how
                    businesses operate. Whether you need a restaurant POS
                    system, inventory management solution, or custom CRM - I
                    build software that automates tedious tasks and provides
                    real value to your business.
                  </p>
                </div>
                <div className="about-details__content-list">
                  <ul>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>
                        Restaurant POS systems with order & inventory management
                      </span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>
                        Inventory management systems for retail businesses
                      </span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>
                        CRM systems with lead tracking & customer management
                      </span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Mobile apps for on-the-go business operations</span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Asset management & employee tracking systems</span>
                    </li>
                    <li>
                      <i className="fal fa-check-square"></i>
                      <span>Custom dashboards with analytics & reporting</span>
                    </li>
                  </ul>
                </div>
                <div className="about-details__text">
                  <p>
                    Every app I build is designed to solve specific business
                    challenges and provide measurable improvements to your
                    operations.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div
                className="about-details__text-2 pt-50 wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".7s"
              >
                <p>
                  <strong>My Approach:</strong> I don't just build apps - I
                  solve business problems. Before writing a single line of code,
                  I spend time understanding your workflow, identifying pain
                  points, and designing solutions that actually make your life
                  easier. Every feature serves a purpose and delivers real
                  value.
                </p>
                <p>
                  <strong>Why Choose Me:</strong> I bring both technical
                  expertise and business understanding to every project. While
                  many developers focus only on coding, I focus on creating
                  software that grows your business. I take time to understand
                  your industry and build solutions that scale with your growth.
                </p>
                <p>
                  <strong>My Process:</strong> Discovery → Design → Development
                  → Deployment → Support. I start by understanding your business
                  needs, then design a custom solution, develop it with regular
                  updates, deploy it smoothly, and provide ongoing support to
                  ensure you get maximum value from your investment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ContactTwo />

      <CTA
        Title="Ready to Transform Your Business?"
        Description="Let's build an app that solves your biggest operational challenges"
        btnText="Start Your Project"
        btnURL="contact"
      />
    </main>
  );
};

export default HomeMain;
